import { Component, OnInit, Input, Injector } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DocumentService } from '../../../ve.service';
import { saveAs } from '@progress/kendo-file-saver';

@Component({
    selector: 'work-order-document-dialog',
    templateUrl: './work-order-document-dialog.template.html',
    styleUrls: ['./work-order-document-dialog.style.scss']
})

export class WorkOrderDocumentDialogComponent implements OnInit {
    @Input() moduleName;
    @Input() workOrderId;

    documentService: DocumentService;
    documents;
    loadingDocuments = false;

    constructor(injector: Injector,
        public dialogRef: MatDialogRef<WorkOrderDocumentDialogComponent>) {
        this.documentService = injector.get(DocumentService);
    }

    ngOnInit() {
        this.getDocuments();
    }

    public openDialog() {
        throw new Error('openDialog is not implemented on component, use injectable service.');
    }

    public closeDialog() {
        this.dialogRef.close();
    }

    private getDocuments() {
        this.loadingDocuments = true;
        this.documentService.read(`/GetByWorkOrderId?workOrderId=${this.workOrderId}`)
            .then(result => {
                this.documents = result.sort((a, b) => a.DocumentType.localeCompare(b.DocumentType));
                this.loadingDocuments = false;
            });
    }

    private handleDocumentDownload(e) {
        const element = e.target;

        if (element) {
            const documentId = element.getAttribute('data-document-id');
            const documentName = element.getAttribute('data-document-name');
            if (documentId) {
                this.loadingDocuments = true;
                this.documentService.documentDownload(`/Downloadfile?documentId=${documentId}`).then(blob => {
                    this.loadingDocuments = false;
                    saveAs(blob, documentName);
                });
            }
        }
    }

}
